export default "__VITE_ASSET__BeXFTEjb__"